import { useUnifyAdminStore } from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import { MultiSelectDropdownMenu } from '../../Notification/Elements/MultiSelectDropdownMenu';
import { useAllApplicationsStore, useAllWorkflowsStore, } from '../../../../Store/index'
import find from 'lodash/find';
import { t } from 'i18next';

export const CustomMultiTargetEditor = ({readOnlyMode}: any): JSX.Element => {

    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);

    const applicationToOptions = (data: any) => {
        if (data && data[0]) {
            const applications = data[0];
            if (applications) {
                const filteredApps = applications.filter(
                    (app: any) =>
                        app.name !== 'Fortellis Marketplace Operations' &&
                        app.name !== 'CDK University' &&
                        app.name !== 'Customer Care' &&
                        app.name !== 'Unify Administration' &&
                        app.name !== 'CDK Resource Center'
                );
                let options = filteredApps.map((application: any) => {
                    return {
                        id: application.appId,
                        label: application.name,
                        value: application.appId,
                    };
                });
                return options;
            }
        }
    };

    const filterWorkflowOptions = (applications: any, workflowsData: any) => {
        let filtered = [] as Option[];
        if (workflowsData) {
            const workflows = workflowsData[0];
            if (workflows) {
                workflows.forEach((workflow: any) => {
                    if (
                        workflow.applications &&
                        workflow.applications[0] &&
                        workflow.applications[0].appId
                    ) {
                        const applId = workflow.applications[0].appId;
                        const found = find(applications, (app: any) => app.id === applId);
                        if (found) {
                            filtered.push({
                                id: workflow.workflowId,
                                label: workflow.name,
                                value: workflow.workflowId,
                            });
                        }
                    }
                });
            }
        }
        return filtered;
    };

    interface Option {
        id: string;
        label: string;
        value: string;

    }

    const applications = useAllApplicationsStore((state: any) => state.applications);
    const workflows = useAllWorkflowsStore((state: any) => state.workflows);

    const applicationOptions = applicationToOptions(applications);
    const workflowOptions = filterWorkflowOptions(
        campaignItems.targetApplications || [],
        workflows
    );
    const updateCreateCampaignData = useUnifyAdminStore((state) => state.updateCreateCampaignData);
    const onApplicationSelect = (applications: any) => {

        updateCreateCampaignData({
            fieldName: 'targetApplications',
            value: applications,
        })

        const filterWorkflowOptions = (applications: any, workflowsData: any) => {
            let filtered = [] as Option[];
            if (workflowsData) {
                const workflows = workflowsData[0];
                if (workflows) {
                    workflows.forEach((workflow: any) => {
                        if (
                            workflow.applications &&
                            workflow.applications[0] &&
                            workflow.applications[0].appId
                        ) {
                            const applId = workflow.applications[0].appId;
                            const found = find(applications, (app: any) => app.id === applId);
                            if (found) {
                                filtered.push({
                                    id: workflow.workflowId,
                                    label: workflow.name,
                                    value: workflow.workflowId,
                                });
                            }
                        }
                    });
                }
            }
            return filtered;
        };

        const workflowOptions = filterWorkflowOptions(applications, workflows);

        //For removing selected workflows when their application deselect
        const selectedWorkflows = { ...campaignItems.targetWorkflows };
        const updatedSelectedWorkflows: any = Object.values(selectedWorkflows).filter(
            (selectedWorkflow: any) =>
                workflowOptions.some(
                    (workflowOption: any) =>
                        workflowOption.id === selectedWorkflow.id
                )
        );
        updateCreateCampaignData({
            fieldName: 'targetWorkflows',
            value: updatedSelectedWorkflows,
        })
    };

    const onWorkflowSelect = (workflows: any) => {
        updateCreateCampaignData({
            fieldName: 'targetWorkflows',
            value: workflows,
        });
    };

    const ontargetEnterpriseChange = (e: any) => {
        updateCreateCampaignData({
            fieldName: 'targetEnterprises',
            value: e.target.value,
        });
        updateCreateCampaignData({
            fieldName: 'uploadedEnterprises',
            value: e.target.value,
        });

        const enterpriseArray = e.target.value.split(',').map((name: string) => name.trim()).filter((name: string) => name !== "");

        const formattedArray: any = enterpriseArray.map((name: any) => ({
            isSelected: true,
            name: name
        }));
        updateCreateCampaignData({
            fieldName: 'gridEnterpriseData',
            value: formattedArray,
        });
    };

    const ontargetStoresChange = (e: any) => {
        updateCreateCampaignData({
            fieldName: 'targetStores',
            value: e.target.value,
        });
        updateCreateCampaignData({
            fieldName: 'uploadedStores',
            value: e.target.value,
        });
        const storesArray = e.target.value.split(',').map((name: string) => name.trim()).filter((name: string) => name !== "");

        const formattedArray: any = storesArray.map((name: string) => ({
            isSelected: true,
            name: name
        }));
        updateCreateCampaignData({
            fieldName: 'gridStoresData',
            value: formattedArray,
        });
    };

    return (
        <div style={{ width: '100%', paddingTop: '15px' }}>
            <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ width: '90%', marginRight: '10px' }}>
                    <MultiSelectDropdownMenu
                        options={applicationOptions || []}
                        name="camp-campaignTargetApplicationss"
                        onSelect={onApplicationSelect}
                        value={campaignItems.targetApplications || ''}
                        label={t('campaigns.targetApplications')}
                        placeholder={t('campaigns.selectApplications')}
                        isDisabled={archiveSwitch}
                    ></MultiSelectDropdownMenu>
                </div>
                <div style={{ width: '90%' }}>
                    <MultiSelectDropdownMenu
                        options={workflowOptions || []}
                        name="camp-campaignTargetWorkflows"
                        onSelect={onWorkflowSelect}
                        value={campaignItems.targetWorkflows || ''}
                        label={t('campaigns.targetWorkflows')}
                        placeholder={t('campaigns.selectWorkflows')}
                        isDisabled={archiveSwitch}
                    ></MultiSelectDropdownMenu>
                </div></div>
            <StyledComponents.StyledInput
                dataTestId={`camp-target-enterprise-desc-input`}
                errorMessage="Error message"
                id={`camp-target-enterprise-name-input`}
                inputDivider="left"
                label={t('campaigns.targetEnterprises')}
                name="camp-targetEnterprises"
                placeholder={'Eg. E123221,E343212'}
                onChange={ontargetEnterpriseChange}
                isDisabled={archiveSwitch}
                value={campaignItems.targetEnterprises}
                hasCharacterCount={true}
                maxLength={24000}
            />
            <StyledComponents.StyledInput
                dataTestId={`camp-target-stores-name-input`}
                errorMessage="Error message"
                id={`camp-target-stores-name-input`}
                inputDivider="left"
                label={t('campaigns.targetStores')}
                name="camp-targetStores"
                placeholder={'Eg. S123221111,S343212111'}
                onChange={ontargetStoresChange}
                value={campaignItems.targetStores}
                hasCharacterCount={true}
                isDisabled={archiveSwitch}
                maxLength={33000}
            />
        </div>
    );
};
